var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat__body",attrs:{"id":"chat__body"}},_vm._l((_vm.msgs),function(msg,index){return _c('chat-message',{key:index,attrs:{"isadmin":_vm.isadmin,"msg":msg,"prev":[index == 0 ? null : _vm.msgs[index - 1]]}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }